import { Box, Typography, withStyles, makeStyles } from '@material-ui/core';
import React from 'react'

const useStyles = makeStyles((theme) => ({
    partCard: {
        borderRadius: "8px",
        padding: "17px 24px",
    },
    partKey: {
        padding: "3px",
        "& p": {
            fontSize: "14px",
        },
    },
    partValue: {
        color: "#4D4F5C",
        padding: "5px",
        display: "flex",
        // alignItems: "center",
        "& p": {
            fontSize: "14px",
        },
    },

}));

function GetInfoCard(props) {
    const classes = useStyles();
    return (
        <Box display="flex" style={{ paddingTop: props?.pt ? props?.pt : "" }}>
            <Box flex={25} className={classes.partKey}>
                <Typography color="primary" style={{ fontWeight: props?.bold && "bold" }}>
                    {props?.keyName}
                </Typography>
            </Box>
            <Box flex={75} className={classes.partValue} >
                {props?.value ?? "-"}
            </Box>
        </Box>)
}

export default GetInfoCard